<template>
  <div id="wrapper" v-if="mailing">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg" v-if="question && project">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: project.id}}">Project Overview</router-link></li>
              <li><router-link :to="{name: 'MailingReview', params: {project_id: project.id, question_id: question.id}}">Mailing Review</router-link></li>
              <li class="active">Mailing Overview</li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Mailing Overview - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: project.id}}">{{project.name}}</router-link>
          </h3>
          <small>Reviewing mailing content and results</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="hpanel no-margins">

        <div class="panel-heading">
          Mailing texts
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Experts added through the platform
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject</label>
                  <div v-html="mailing.template.subject"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-md-6">

            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Manually added experts
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject </label>
                  <div v-html="mailing.template.subject_manual"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body_manual"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="hpanel">

        <div class="panel-heading">
          Contacted Experts
        </div>

        <div class="panel-body" >
          <experts-contacted :experts="mailing.authors" :eventsExperts="mailing.events_authors"/>
        </div>

      </div>

      <div class="hpanel" v-if="mailing">
        <div class="panel-heading">
          Actions
        </div>
        <div class="panel-body text-center">
          <div class="col-xs-12 border-right">
            <router-link class="btn btn-info" :to="{name: 'MailingReview', params: {project_id: project.id, question_id: question.id}}"><i class="fa fa-arrow-left"></i> Back to Mailing Review</router-link>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import VueLadda from 'vue-ladda'
import ExpertsContacted from '../../components/mailing/ExpertsContacted'

export default {
  components: {
    ExpertsContacted,
    VueLadda},
  props: [],
  name: 'MailingOverview',
  methods: {
    getResources: function () {
      this.axios.get('/mailing/' + this.mailingId + '?relations={question,question.project,template}')
        .then((response) => {
          this.mailing = response.data

          this.question = this.mailing.question
          this.project = this.mailing.question.project
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    }
  },
  data () {
    return {
      project: null,
      question: null,
      mailingId: null,
      mailing: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
  },
  beforeMount () {
    this.mailingId = parseInt(this.$route.params.mailing_id)

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/MailingOverview.vue